function productSlider(){
    const containers = window.document.querySelectorAll('.js_product-slider');

    if(containers.length < 1) return;

    containers.forEach(container => {
        const options = {
            contain:true,
            cellAlign:'left',
            percentPosition:false,
            pageDots:false,
            prevNextButtons:false,
            wrapAround:true,
            initialIndex:0
            };
        const flickitySlider = new Flickity(container,options);
        flickitySlider.on('dragStart', () => flickitySlider.slider.style.pointerEvents = 'none');
        flickitySlider.on('dragEnd', () => flickitySlider.slider.style.pointerEvents = 'auto');
    })
}

window.addEventListener('load',productSlider);
